import axios from "axios";
import { useEffect, useState } from "react";
import { link } from "../../../../config";
import { useTranslation } from "react-i18next";

function Price({ product }) {
  const [finalPrice, setFinalPrice] = useState(0);
  const [siteWideDiscount, setSiteWideDiscount] = useState(null);
  const [showPercentageDiscount, setShowPercentageDiscount] = useState(true);
  const [totalDiscountPercentage, setTotalDiscountPercentage] = useState(0);
  const { t } = useTranslation();

  // Fetch the site-wide discount
  const fetchDiscountSiteWide = async () => {
    try {
      const { data } = await axios.get(`${link}site-wide-discount`);
      setSiteWideDiscount(data.siteWideDiscount || {});
    } catch (error) {
      console.log(error);
      setSiteWideDiscount({});
    }
  };

  // Calculate total discount from todayDiscount and flashDiscount
  const calculateAdditionalDiscountPercentage = () => {
    const productPrice = product?.price_before || 0;
    const totalDiscountToday = (product?.todayDiscount || []).reduce(
      (sum, m) => sum + m.discount,
      0
    );
    const totalDiscountFlash = (product?.flashDiscount || []).reduce(
      (sum, m) => sum + m.discount,
      0
    );

    // Convert additional discounts into a percentage of the original price
    const additionalDiscountPercentage =
      ((totalDiscountToday + totalDiscountFlash) / productPrice) * 100;

    return additionalDiscountPercentage || 0; // Ensure it returns 0 if NaN or undefined
  };

  // Calculate final price based on all discounts
  const calculatePrice = () => {
    const productPrice = product?.price_before || 0; // Default to 0 if undefined
    const productDiscount = product?.discount || 0; // Default to 0 if undefined

    let productDiscountValue = productPrice * (productDiscount / 100); // Product discount value
    let siteWideDiscountValue = 0;

    // Check if site-wide discount is active
    if (siteWideDiscount) {
      if (siteWideDiscount.discountFlatRateActive) {
        siteWideDiscountValue = siteWideDiscount.discountFlatRate || 0; // Default to 0 if undefined
      } else if (siteWideDiscount.discountPercentageActive) {
        const discountPercentage = siteWideDiscount.discountPercentage || 0; // Default to 0 if undefined
        siteWideDiscountValue = productPrice * (discountPercentage / 100);
      }
    }

    // Apply the greater discount
    const appliedDiscount = Math.max(productDiscountValue, siteWideDiscountValue);

    // Calculate additional discounts
    const additionalDiscountPercentage = calculateAdditionalDiscountPercentage();
    const additionalDiscountValue = (productPrice * additionalDiscountPercentage) / 100;

    const newPrice = productPrice - appliedDiscount - additionalDiscountValue;

    // Determine whether to show the percentage discount
    if (siteWideDiscount.discountFlatRateActive && siteWideDiscountValue > productDiscountValue) {
      setShowPercentageDiscount(false);
    } else {
      setShowPercentageDiscount(true);
    }

    // Update the total discount percentage
    setTotalDiscountPercentage(
      Math.max(
        productDiscount,
        siteWideDiscount?.discountPercentage || 0
      ) + additionalDiscountPercentage
    );

    // Update the final price
    setFinalPrice(Math.max(newPrice, 0)); // Ensure price doesn't go below zero
  };

  useEffect(() => {
    fetchDiscountSiteWide();
  }, []);

  useEffect(() => {
    if (siteWideDiscount) {
      calculatePrice();
    }
  }, [siteWideDiscount, product]);

  return (
    <>
      <div className="product-price d-flex align-items-center gap-2">
        <p className="new">
          <span>{t('curency')}</span> {finalPrice.toFixed(2)}
        </p>
        <p className="old">{t('curency')} {product?.price_before || t("Out of Stock")}</p>
        {showPercentageDiscount && (
          <p className="sale text-danger">
            {totalDiscountPercentage.toFixed(2)}% {t("Discount")}
          </p>
        )}
      </div>
      <p className="beans">{t("Price includes VAT")}</p>
    </>
  );
}

export default Price;
